<template>
    <div class="intelligence-chart">
        <h3 class="intelligence-chart__title">{{ $t('pages.intelligence.provider_performance.charts.top_providers') }}</h3>
        <div v-if="hasData" class="intelligence-chart__body">
            <apexchart type="bar" height="280" :options="chartOptions" :series="series"></apexchart>
        </div>
        <p v-else class="intelligence-chart__empty">{{ $t('pages.intelligence.provider_performance.empty') }}</p>
    </div>
</template>

<script>
    export default {
        props: {
            providers: {
                type: Array,
                default: () => [],
            },
        },

        computed: {
            topProviders() {
                return this.providers.slice(0, 8)
            },

            hasData() {
                return this.topProviders.some((row) => row.responses > 0)
            },

            series() {
                return [
                    {
                        name: this.$t('pages.intelligence.provider_performance.table.responses'),
                        data: this.topProviders.map((row) => row.responses),
                    },
                ]
            },

            chartOptions() {
                return {
                    chart: {
                        type: 'bar',
                        toolbar: { show: false },
                    },
                    plotOptions: {
                        bar: {
                            borderRadius: 4,
                            columnWidth: '55%',
                            horizontal: true,
                        },
                    },
                    colors: ['#1e3a8a'],
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        categories: this.topProviders.map((row) => row.displayName),
                    },
                    grid: {
                        borderColor: '#e5e7eb',
                    },
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .intelligence-chart {
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 12px;
        padding: 20px;
    }

    .intelligence-chart__title {
        margin: 0 0 16px;
        font-size: 16px;
        font-weight: 600;
        color: #111827;
    }

    .intelligence-chart__empty {
        margin: 0;
        color: #6b7280;
        font-size: 14px;
    }
</style>
